import { CommonDataDTO } from '@app/requests/model/combos-model';

export interface TpvBuyDTO {
  amount: string;
  contractNumber: string;
  description: string;
  establishment: string;
  monthlyPayment: number;
  nif: string;
  rate: string;
}

export interface TpvResponseDTO {
  datosBoletaBean: TpvBuyPrintRequestDTO;
  errorCode: string;
  result: string;
}

export interface TpvRefundDTO {
  amount: string;
  authorization: string;
  contractNumber: string;
  description: string;
  establishment: string;
  nif: string;
}

export interface TpvBuyPrintRequestDTO {
  strAutorizacion: string;
  strCodEstablecimiento: string;
  strCodPrescriptor: string;
  strCuota: string;
  strCuotaFinal: string;
  strEstablecimiento: string;
  strFecha: string;
  strFechaDevol: string;
  strHora: string;
  strIdBenef: string;
  strIdEstablecimiento: string;
  strImComApc: string;
  strImporte: string;
  strImporteTot: string;
  strInFpCoAp: string;
  strNifNie: string;
  strNomBenef: string;
  strNumContrato: string;
  strOperOriginal: string;
  strPlazos: string;
  strPrescriptor: string;
  strTae: string;
  strTin: string;
  strTipoOperacion: string;
  strTitular: string;
}

export interface EstablishmentDTO {
  id: string;
}

export interface TPVTariffDTO {
  code: string;
  description: string;
  terms: TermDTO[];
}

export interface TermDTO {
  value: string;
}

export interface TPVTariff {
  id: string;
  value: string;
  terms: CommonDataDTO[];
}

export enum TPVOptionOperations {
  liquidations = 'T',
  purchase = 'C',
  refund = 'D',
}

export enum TPVTypeSelected {
  group = 'C',
  prescriptor = 'P',
  establishment = 'E',
}

export interface TpvDetailDTO {
  authorization: string;
  contract: string;
  dateFrom: string;
  dateTo: string;
  language: string;
  operationType: string;
  printDocumentType: string;
  selectedGroupType: string;
  selectedNifCifType: string;
  selectedPageId: string;
  stablishment: string;
  userId: string;
  userType: string;
}

export interface TpvDetailOperation {
  dblGastos: number;
  dblImModLoc: number;
  dblImpNeto: number;
  strApell1: string;
  strApell2: string;
  strDescripcion: string;
  strDniCif: string;
  strFecha: string;
  strFechaLiq: string;
  strIdEstablecimiento: string;
  trIdPrescriptor: string;
  strNombre: string;
  strNuCuotas: string;
  strNuRefere: string;
  strNumCon: string;
  strTipOper: string;
}

export interface TpvOperation {
  objDetalleOperacionTarjetaBean: TpvDetailOperation[];
  strDescripcionUsuario: string;
  strUsuarioPk: string;
}

export interface TpvQueryResponse {
  lpaginacion: string[];
  objOperacionTarjetaBean: TpvOperation[];
  strClavePag: string;
  strCrtPag: string;
  strNombreCli: string;
  strNumPagina: string;
}

export interface TpvBoleta {
  authorization: string;
  contract: string;
  operationType: string;
  stablishment: string;
  userId: string;
}
